export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-sheriff-badge-939c4c00853f4f8914578f76d83b03db.svg";